import ExtendableError from 'es6-error'

export const NETWORK_REQUEST_FAILED = 'Network request failed'
export const INVALID_USERNAME_OR_PASSWORD = 'Invalid username or password'

const exceptionTypeCodes = [
	NETWORK_REQUEST_FAILED, INVALID_USERNAME_OR_PASSWORD
]

export default class FetchError extends ExtendableError{
	constructor(response, message=undefined, code=undefined){
		if(!message){
			message = response.statusText || [response.status, response._bodyText, response.message].filter(text => text).join(' : ')
		}

		super(message)
		this.message = message
		this.code = code || exceptionTypeCodes.find(item => item === message) || 'UNKNOWN'
		this.response = response
		this.json = response.headers && response.headers.get('Content-Type').includes('json') ? () => response.clone().json() : undefined
	}
}

/**
 * Resolves the json from the response and will trigger the exception with the correct message + code
 * @param response
 * @return {Promise}
 * @constructor
 */
export function FetchErrorPromiseResolver(response){
	return new Promise((accept, reject) => {
		if(response.headers && response.headers.get('Content-Type').includes('json')){
			response.clone().json().then((json) => {
				reject(new FetchError(response, json.message || json.Message || json.ErrorMessage || json.error_description, json.code || json.Code || json.ErrorCode || json.error_code))
			})
		}else{
			reject(new FetchError(response))
		}
	})
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/error/fetch-error.js